import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<string | null>(null);
  const openModal = (modalType: string) => {
    setActiveModal(modalType);
  };
  const closeModal = () => {
    setActiveModal(null);
  };
  const termsContent = <div className="space-y-4" data-id="element-47">
      <h4 className="font-bold" data-id="element-48">1. Términos de Uso</h4>
      <p data-id="element-49">
        Al acceder y utilizar "50 Recetas en 5 Minutos", aceptas cumplir con
        estos términos y condiciones.
      </p>
      <h4 className="font-bold" data-id="element-50">2. Propiedad Intelectual</h4>
      <p data-id="element-51">
        Todo el contenido es propiedad exclusiva de los creadores y está
        protegido por leyes de propiedad intelectual.
      </p>
      <h4 className="font-bold" data-id="element-52">3. Uso Personal</h4>
      <p data-id="element-53">
        La compra otorga una licencia personal e intransferible. No está
        permitida la reventa o distribución.
      </p>
    </div>;
  const privacyContent = <div className="space-y-4" data-id="element-54">
      <h4 className="font-bold" data-id="element-55">Privacidad y Datos</h4>
      <p data-id="element-56">
        Respetamos tu privacidad. La información recopilada durante la compra se
        utiliza únicamente para procesar tu pedido y enviarte el producto.
      </p>
      <p data-id="element-57">
        No compartimos tus datos con terceros salvo para el procesamiento del
        pago (plataforma segura).
      </p>
    </div>;
  const contactContent = <div className="space-y-4" data-id="element-58">
      <h4 className="font-bold" data-id="element-59">Contacto y Soporte</h4>
      <p data-id="element-60">¿Tienes preguntas o necesitas ayuda con tu descarga?</p>
      <p className="font-medium" data-id="element-61">Email: soporte@cocinasinestres.com</p>
      <p data-id="element-62">Horario: Lunes a Viernes, 9:00 - 18:00</p>
    </div>;
  return <footer className="bg-gray-900 text-white py-12" data-id="element-63">
      <div className="container mx-auto px-4 text-center" data-id="element-64">
        <h3 className="text-2xl font-bold mb-6 text-rose-400" data-id="element-65">
          Cocina Sin Estrés™
        </h3>

        <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm text-gray-400" data-id="element-66">
          <button onClick={() => openModal('terms')} className="hover:text-white transition-colors" data-id="element-67">
            Términos de Uso
          </button>
          <button onClick={() => openModal('privacy')} className="hover:text-white transition-colors" data-id="element-68">
            Política de Privacidad
          </button>
          <button onClick={() => openModal('contact')} className="hover:text-white transition-colors" data-id="element-69">
            Contacto
          </button>
        </div>

        <p className="text-xs text-gray-600 mb-4" data-id="element-70">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio no está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>

        <p className="text-xs text-gray-600" data-id="element-71">
          © 2026 Cocina Sin Estrés. Todos los derechos reservados.
        </p>
      </div>

      <LegalModal isOpen={activeModal === 'terms'} onClose={closeModal} title="Términos y Condiciones" content={termsContent} data-id="element-72" />
      <LegalModal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Política de Privacidad" content={privacyContent} data-id="element-73" />
      <LegalModal isOpen={activeModal === 'contact'} onClose={closeModal} title="Contacto" content={contactContent} data-id="element-74" />
    </footer>;
}